// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"ppme-slug","396":"ppme-grab","673":"ppme-shared","897":"ppme-settings"}[chunkId] || chunkId) + ".bundle.js";
};